import actions from './actions';
import mutations from './mutations';

const initialState = () => {
  return {
    total: 0,
    loadingAction: {
      ...Object.keys(actions).reduce((obj, action) => {
        return { ...obj, [action]: false };
      }, {})
    },
    errorAction: {
      ...Object.keys(actions).reduce((obj, action) => {
        return { ...obj, [action]: false };
      }, {})
    },
    progressAction: {
      ...Object.keys(actions).reduce((obj, action) => {
        return { ...obj, [action]: false };
      }, {})
    },
    invoiceValidations: [],
    invoiceValidation: {},
    invoices: [],
    listFilters: {
      $sort: 'createdAt:-1'
    },
    counts: {
      queue: 0,
      passed: 0,
      failed: 0
    },
    statusClass: {
      warning: 'text-warning',
      failed: 'text-danger',
      passed: 'text-success'
    },
    statusIcon: {
      warning: 'fa-triangle-exclamation',
      failed: 'fa-circle-xmark',
      passed: 'fa-circle-check'
    }
  };
};

const store = {
  namespaced: true,
  state: initialState(),
  getters: {
    loadingAction: state => state.loadingAction,
    errorAction: state => state.errorAction,
    progressAction: state => state.progressAction,
    validationErrors: state => state.validationErrors,
    total: state => state.total,
    invoiceValidations: state => state.invoiceValidations,
    invoiceValidation: state => state.invoiceValidation,
    statusClass: state => state.statusClass,
    statusIcon: state => state.statusIcon,
    invoices: state => state.invoices,
    counts: state => state.counts
  },
  mutations: {
    RESET_STATE: state => {
      Object.assign(state, initialState());
    },
    ...mutations
  },
  actions: {
    ...actions
  }
};

export default store;
